import request from '@/utils/request'

export function signIn(data) {
    console.log(data.getAll('file'))
    request.interceptors.request.use(
        config => {
            // config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
            config.headers['Content-Type'] = 'multipart/form-data;charset=utf-8'
            // delete config.headers.Content-Type

            config.processData = false
            console.log(config)
            return config
        },
        error => {
            console.log(error)
            return Promise.reject(error)
        }
    )
    return request({
        url: '',
        method: 'post',
        data
    })
}


export function signList(data) {
    return request({
        url: '',
        method: 'post',
        data
    })
}

export function companyList(data) {
    return request({
        url: '',
        method: 'post',
        data
    })
}

export function getImage(data) {
    return request({
        url: '',
        method: 'post',
        data
    })
}